import { render, staticRenderFns } from "./NotificarSintomasView.vue?vue&type=template&id=3885a09a&scoped=true&"
import script from "./NotificarSintomasView.vue?vue&type=script&lang=js&"
export * from "./NotificarSintomasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885a09a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
